import { render, staticRenderFns } from "./stockReview.vue?vue&type=template&id=4b01e2a4&"
import script from "./stockReview.vue?vue&type=script&lang=js&"
export * from "./stockReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports